<template>
    <div class="common-fix-bg">
		<div class="wrap">
			<h3>
				<img src="@/assets/img/cusMessage.png"/>
				<span>Order submitted !</span>
			</h3>
			<div class="tips">
				<p>Kindly pay attention to our mobile number, as we will call you to briefly confirm your loan application.</p>
				<p> If answering the phone is inconvenient, you can leave a message below the best time to reach you.</p>
			</div>
			<div class="con-time">
				<p>Your best hour anwer our call:</p>
				<span class="pop-list" @click="openPop">{{freeHour}}</span>
			</div>
			
			<textarea rows="2" cols="50" v-model="customerMessage"></textarea>
			<div class="btn-wrap">
				<span class="submit" @click="submit">Submit Message</span>
				<span class="close" @click="close">Close</span>
			</div>
		</div>
		
		<pop-list v-if="showPop" :data="popData" @chooseOpt="chooseVal" @closePop="showPop=false"></pop-list>
    </div>
</template>

<script>
	import popList from "./popList";
export default {
	data(){
	    return {
			popData: {},
			showPop:false,
			timeList:[],
			customerMessage:"",
			freeHour:'Please hour'
	    }
	},
	
	created() {
		this.getSjd()
	},
	
	methods:{
		// 提交留言
		submit(){
			let self = this;
			if(this.customerMessage === ''){
				self.UTILS.logStr('please enter your message');
				return;
			}
			const parmas = {
				customerMessage:this.customerMessage,
				freeHour:this.freeHour == 'Please hour' ? '' : this.freeHour
			}
			this.$emit("submitMessage",parmas)
		},
		
		close(){
			this.$emit("close")
		},
		
		getSjd(){
			let self = this;
			self.UTILS.axiosRequest('post', self.PATHS.loanPath + '/user/getSjd', {}, function(res) {
				self.UTILS.loadGif.hide();
				if (res.code == '0000') {
					self.timeList = res.data || [];
				}
			}, 1);
		},
		
		//打开弹窗
		openPop(){
			this.popData = {};
			this.popData = {
				title: 'Please select time',
				list: this.timeList
			}
			this.showPop = true;
		},
		
		chooseVal(item){
			this.freeHour = item;
		}
	},
	
	components:{
		popList
	}
}
</script>

<style scoped>

.common-fix-bg {
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background: rgba(0, 0, 0, .7);
    z-index: 10;
	display: flex;
	align-items: center;
	justify-content: center;
}

.common-fix-bg .wrap {
	width: 90%;
	padding: 0.3rem;
	border: 1px solid #ED5B0E;
    border-radius: 0.2rem;
	background: #FFFFFF;
}
.common-fix-bg .wrap h3{
	display: flex;
	align-items: center;
}
.wrap h3 img{
	width: 0.5rem;
	height: 0.5rem;
	margin-right: 0.2rem;
}
.wrap h3 span{
	color: #010101;
	font-size: 0.24rem;
	font-weight: bold;
}
.wrap .tips{font-family: Arial;font-size: 0.28rem; color: #6F6F6F; margin-top: 0.1rem;}
.wrap .tips p{margin-top: 0.1rem;}
.wrap .con-time{margin-top: 0.5rem;}
.wrap .con-time p{font-size: 0.24rem;color: #3D3D3D;font-weight: 500;}
.wrap .pop-list{
	width: 100%;
	height: 0.86rem;
	line-height: 0.86rem;
	padding-left: 0.32rem;
	font-size: 0.3rem;
	background: url("~@/assets/img/select.png") no-repeat 95% center;
	background-size: 0.31rem 0.17rem;
	border: 0.02rem solid #d7d7d7;
	border-radius: 0.06rem;
	display: block;
	margin: 0.16rem auto 0 auto;
}

.wrap textarea{width: 100%;padding: 0.1rem;border-color: #8D8989;margin-top: 0.2rem;font-size: 0.28rem;}
.wrap .btn-wrap{padding: 0 0.5rem;display: flex;align-items: center;justify-content: space-between;margin-top: 0.4rem;}
.wrap .btn-wrap span{
	padding: 0.1rem 0.2rem;
	box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.5);
	border-radius:0.16rem;
	color: #FCFCF9;
	font-weight: bold;
	font-size: 0.28rem;
}
.wrap .btn-wrap .submit{background: #ED5B0E;}
.wrap .btn-wrap .close{background: #7484FF;}
</style>



